import React from "react";

export default function ContentHeader({ title, caption }) {
  return (
    <div className="contentHeader">
      <h1>ITS JumpStart</h1>
      <h2>{title}</h2>
      <p>{caption}</p>
    </div>
  );
}
